import React from 'react'

export const BkFlowInput = ({ input, name, label, type, size, labelLink, labelLinkText, required, meta: { valid, touched, error } }) => (
  <div className={
    touched && error ?
      'u-form-col u-form-col--error u-form-col--' + size
    : touched && valid ?
      'u-form-col u-form-col--valid u-form-col--' + size
    :
      'u-form-col u-form-col--' + size
  }>
    <label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>
      { required && '*' }

      { label }

      { labelLink &&
        <a
          className='u-form-label-link u-font-small'
          href={labelLink}
          target="_blank" 
          rel="noopener noreferrer"
          tabIndex={ 0 }
        >
					{ labelLinkText }
				</a>
      }
    </label>

    <input
      { ...input }
      type={ type }
      aria-labelledby={ input.name + 'Label' }
      required={required}
      aria-required={required ? true : false}

    />

    { touched && ((error && <p className="u-font-error" aria-live="assertive">{error}</p>)) }
  </div>
)



// WEBPACK FOOTER //
// ./src/components/forms/elements/BkFlowInput.js